var React = require('react');

function Copyto (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".copyto-cls-1{fill:#e14871;}.copyto-cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:9.4px;}")),React.createElement("title",{"key":1},"mask map 06"),React.createElement("g",{"id":"text","key":2},[React.createElement("circle",{"className":"copyto-cls-1","cx":"95.44","cy":"95.44","r":"95.44","key":0}),React.createElement("rect",{"className":"copyto-cls-2","x":"65.44","y":"54.93","width":"72.02","height":"94.69","rx":"12.29","key":1}),React.createElement("path",{"className":"copyto-cls-2","d":"M48.29,125.11V62A23.9,23.9,0,0,1,72.18,38.08h40.46","key":2})])]);
}

Copyto.defaultProps = {"viewBox":"0 0 190.88 190.88"};

module.exports = Copyto;

Copyto.default = Copyto;
